var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.390361 9.428L7.93303 16.9707L9.81836 15.0853L3.21836 8.48533L9.81836 1.88533L7.93303 0L0.390361 7.54267C0.140399 7.7927 -2.19345e-05 8.13178 -2.19345e-05 8.48533C-2.19345e-05 8.83889 0.140399 9.17797 0.390361 9.428Z",
    fill: "#658479"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationPrev);
export default __webpack_public_path__ + "static/media/PaginationPrev.c6a11575a8adb5a97957b50fc6b4ee0b.svg";
export { ForwardRef as ReactComponent };